import axios, { type AxiosResponse } from 'axios';

import { type ReviewsPartner } from '../types/types';

type ReviewsYotpo = {
    found_filtered_reviews: boolean;
    pagination: {
        page: number;
        per_page: number;
        total: number;
    };
    bottomline: {
        total_review: number;
        average_score: number;
        total_organic_reviews: number;
        organic_average_score: number;
        star_distribution: {
            1: number;
            2: number;
            3: number;
            4: number;
            5: number;
        };
    };
    reviews: Array<{
        id: number;
        score: number;
        votes_up: number;
        votes_down: number;
        content: string;
        title: string;
        created_at: string;
        deleted: boolean;
        verified_buyer: boolean;
        comment: string;
        user: {
            user_id: number;
            display_name: string;
        };
    }>;
};

export const fetchExternalProductReviewsFromPartner = async (
    reviewPartnerAppKey: string,
    productId: string,
): Promise<ReviewsPartner> => {
    const url = `https://api-cdn.yotpo.com/v1/widget/${reviewPartnerAppKey}/products/${productId}/reviews.json?per_page=5`;
    const { data }: AxiosResponse<{ response: ReviewsYotpo }> = await axios.get(url);
    return {
        totalReview: data.response.bottomline.total_review,
        averageScore: data.response.bottomline.average_score,
        reviews: data.response.reviews.map(review => ({
            id: review.id,
            score: review.score,
            content: review.content,
            title: review.title,
            createdAt: review.created_at,
            verifiedBuyer: review.verified_buyer,
            comment: review.comment,
            userName: review.user.display_name,
        })),
    };
};
